module.exports = __webpack_public_path__ + "static/Verkada-081a109fceac493e636dd9e063291890.jpg";